<script setup lang="ts">
import {Motion} from 'motion-v'
import type {Byte} from '~/payload-types'

const props = defineProps<{
  byte: Byte
  card?: boolean
}>()

const liked = ref(props.byte?.liked ?? false)
const likes = ref(props.byte?.likesCount || 0)

const {toggle} = useLike(props.byte.id)

const like = async () => {
  liked.value = !liked.value

  // there must be a better way to write this but my brain is dead
  if (props.byte.liked && liked.value) likes.value++
  if (props.byte.liked && !liked.value) likes.value--
  if (!props.byte.liked && liked.value) likes.value++
  if (!props.byte.liked && !liked.value) likes.value--

  await toggle()
}
</script>

<template>
  <button
    v-if="card"
    @click.prevent="like"
    class="relative flex w-20 cursor-pointer flex-col items-center justify-center space-y-1 overflow-hidden rounded-md border border-gray-300 bg-gray-100 px-3 py-3 hover:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-50"
  >
    <div class="relative flex h-4 w-4 items-center justify-center">
      <AnimatePresence mode="popLayout">
        <Motion
          v-if="liked"
          :initial="{scale: 0, filter: 'blur(16px)'}"
          :animate="{scale: 1.25, filter: 'blur(0px)'}"
          :exit="{scale: 0, filter: 'blur(16px)'}"
        >
          <Icon size="16" class="text-red-500" name="material-symbols:favorite" />
        </Motion>
        <Motion
          v-else
          :initial="{scale: 0, filter: 'blur(16px)'}"
          :animate="{scale: 1, filter: 'blur(0px)'}"
          :exit="{scale: 0, filter: 'blur(16px)'}"
        >
          <Icon class="text-gray-600" size="16" name="material-symbols:favorite-outline" />
        </Motion>
      </AnimatePresence>
    </div>

    <span class="text-xs">{{ likes }}</span>
  </button>

  <div v-else class="flex items-center space-x-1 text-gray-600">
    <span class="text-xs lg:text-sm">{{ likes }}</span>
    <div class="relative">
      <Icon class="text-gray-600" size="10" aria-label="likes" name="material-symbols:favorite" />
    </div>
  </div>
</template>
